module.exports = __webpack_public_path__ + "static/img/Brandon-Ellis.d03f511.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Brandon-Ellis.jpg
// module id = S3ly
// module chunks = 0